var _path, _g, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconStart = function SvgIconStart(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: 14,
    height: 14,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.76,13.76) scale(0.84,0.84)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "none",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontSize: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f1c40f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.08333,57.33333v-14.33333h-10.75v-14.33333h-7.16667v-14.33333h-14.33333v14.33333h-7.16667v14.33333h-10.75v14.33333h-53.75v10.75h14.33333v10.75h14.33333v10.75h10.75v17.91667h-7.16667v17.91667h-7.16667v14.33333h-7.16667v17.91667h10.75v-7.16667h17.91667v-10.75h17.91667v-10.75h28.66667v10.75h17.91667v10.75h17.91667v7.16667h10.75v-17.91667h-7.16667v-14.33333h-7.16667v-17.91667h-7.16667v-17.91667h10.75v-10.75h14.33333v-10.75h14.33333v-10.75z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-start.381e2bbe.svg";
export { ForwardRef as ReactComponent };